import { getFeatureFlags } from 'core/userContext';
import { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import { FeatureFlagContext } from './FeatureFlagContext';

export const FeatureFlagContextProvider = ({ children }: { children: ReactNode }) => {
  const featureFlags = useSelector(getFeatureFlags);
  const isCampaignAnalyticsReactificationEnabled = !!featureFlags?.CampaignAnalyticsReactification;
  const isInAppRecallUIEnabled = !!featureFlags?.InAppRecallUI;
  const isSuspendSendsEnabled = !!featureFlags?.SuspendSends;

  return (
    <FeatureFlagContext.Provider
      value={{
        isCampaignAnalyticsReactificationEnabled,
        isInAppRecallUIEnabled,
        isSuspendSendsEnabled,
      }}
    >
      {children}
    </FeatureFlagContext.Provider>
  );
};
